<app-button
  variant="ghost"
  class="ord-modal-button-close"
  svgIcon="close"
  ariaLabel="Close"
  (btnClick)="closeDialog()"
/>
<h2 mat-dialog-title class="ord-modal-title">
  <mat-icon
    svgIcon="error"
    class="ord-icon ord-icon-lg ord-text-red"
  ></mat-icon>
  <span>Error</span>
</h2>
<mat-dialog-content class="ord-modal-content">
  <div [innerHTML]="formattedMessage"></div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="ord-modal-actions">
  <app-button
    variant="secondary"
    (btnClick)="confirm()"
  >
    <ng-template appButtonText> Ok </ng-template>
  </app-button>
</mat-dialog-actions>
